import AboutUsImage from "../../../assets/images/aboutUs.jpg";

const AboutUs = () => {
  return (
    <div className="services-section about-section">
      <div className="about-section-content">
        <div className="nav-bold secondary">About Us</div>
        <h2>
          Built on Experience,{" "}
          <span style={{ fontStyle: "italic" }}>Driven by Purpose</span>
        </h2>
        <div className="row">
          <div>
            <img src={AboutUsImage} alt="About Us" className="image" />
          </div>

          <div className="column align-left" style={{ textWrap: "wrap" }}>
            <div className="nav-bold align-left" style={{ textWrap: "wrap" }}>
              EdwardCoombs Ltd was founded by Matt Edwards.
            </div>
            <div className="content-bold">
              Matt Edwards served as a Combat Medic in the Royal Army Medical
              Corps. That background shaped everything that followed: discipline
              under pressure, clarity in complexity, and an unshakeable
              commitment to the people in his care.
            </div>
            <div className="content">
              Since leaving the Army, Matt has built a proven track record
              across wealth management and financial planning — working with
              first-time buyers, families, and high-net-worth individuals alike.
              One principle has remained constant throughout: the client's
              interest comes first, always.
            </div>
            <div className="content">
              Edward Coombs Ltd was founded to deliver what the industry too
              rarely offers — truly independent, whole-of-market advice that is
              rigorous, transparent, and built around your life. As an
              FCA-regulated firm, every recommendation we make is held to the
              highest professional standard, with no ties to any provider or
              product.
            </div>
            {/* <div className="content">
              Matt’s goal is to create products and services to help individuals
              and families develop credible and robust financial plans. He is
              passionate about helping others.
            </div>
            <div className="content">
              Matt has access to a national team with vast experience across all
              aspects of financial services. Matt and the team look forward to
              helping you build financial resilience and securing your future.
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
